import { Box } from "@saleor/macaw-ui-next";
import { Package } from "lucide-react";
import { useState } from "react";

export const LabelThumbnail = ({ url }: { url: string | null }) => {
  // A thumbnail URL can point at a file the server no longer has (stale
  // thumbnail rows on prod); show the placeholder rather than a broken image.
  // Keyed by url, so a new url gets a fresh try.
  const [failedUrl, setFailedUrl] = useState<string | null>(null);

  return (
    <Box
      display="grid"
      placeItems="center"
      borderWidth={1}
      borderStyle="solid"
      borderColor="default1"
      borderRadius={2}
      backgroundColor="default2"
      overflow="hidden"
      __width="40px"
      __height="40px"
    >
      {url && failedUrl !== url ? (
        <img
          src={url}
          alt=""
          onError={() => setFailedUrl(url)}
          style={{ width: "100%", height: "100%", objectFit: "contain" }}
        />
      ) : (
        <Package size={18} aria-hidden />
      )}
    </Box>
  );
};
